import type { Theme } from "@mui/material/styles";

declare module "@mui/material/styles" {
  interface Palette {
    yellow: Palette["primary"];
  }

  interface PaletteOptions {
    yellow?: PaletteOptions["primary"];
  }
}

declare module "@mui/material/Chip" {
  interface ChipPropsColorOverrides {
    yellow: true;
  }
}

export const addYellow = (theme: Theme) =>
  theme.palette.augmentColor({
    color: { main: "#fbc02d" },
    name: "yellow",
  });
